import {useState} from "react";
import {Checkbox, Icon, TextField} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import {defaultImage} from "../../ApplicationDesigner/Designers/ScreenDesigner/ScreenBar/ScreenComponents/ImageComponent";
import request from "../../../../Services/API/Requests";

const FromScratch = () => {
    const [data, setData] = useState({
        id: "",
        name: "",
        public: false,
        image: defaultImage,
    })

    function onChangeFields({target: {name, value}}) {

        setData(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    function onChangeCheckbox({target: {name, checked}}) {
        setData(prev => {
            return {
                ...prev,
                [name]: checked
            }
        })
    }

    function onChangeFile(e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            let objUrl = URL.createObjectURL(file);

            setData(prev => {
                return {
                    ...prev,
                    image: objUrl
                }
            })
        }
    }


    async function onCreate() {
        try {
            const res = await request({
                url: '/application/create',
                data,
            })
        } catch (e) {

        }
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            minHeight: 422,
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 20,
                width: '50%'
            }}>
                <TextField
                    label={'Application Identifier'}
                    name={'id'}
                    placeholder={"e.g web"}
                    autoFocus={true}
                    variant={"outlined"}
                    value={data.id}
                    size={"small"}
                    onChange={onChangeFields}
                />
                <TextField
                    label={'Application Name'}
                    name={'name'}
                    variant={"outlined"}
                    value={data.name}
                    size={"small"}
                    style={{
                        marginTop: 15
                    }}
                    onChange={onChangeFields}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={data.public}
                            onChange={onChangeCheckbox}
                            name="public"
                            color="primary"
                        />
                    }
                    label="Public"
                />
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 10,
                width: '50%',
                background: '#f7f7f7'
            }}>
                <div style={{
                    minHeight: 250
                }}>
                    <img src={data.image} alt={'default_image'} width={250}
                         style={{
                             marginBottom: 10
                         }}
                    />
                </div>

                <span>
                <input id={'app_image'}
                       type="file"
                       onChange={onChangeFile}
                       style={{display: "none"}}
                />
                <label htmlFor={'app_image'}>
                    <Button
                        variant={"outlined"}
                        component={'span'}
                    >
                        Upload Application Image
                        <Icon color={"disabled"} style={{marginLeft: 10}}>
                            upload
                        </Icon>
                    </Button>
                </label>
                    </span>
            </div>
        </div>
    )
}

export default FromScratch;